import axios from "axios";
import { useCallback, useState } from "react";

const useLazyFetch = (url, initialHeaders = {}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fetchCount, setFetchCount] = useState(0);

  const fetchData = useCallback(
    async (fetchParams, additionalHeaders = {}) => {
      setLoading(true);
      setError(null);
      setFetchCount((prevCount) => prevCount + 1); // Increment fetch count
      try {
        const response = await axios.get(url, {
          params: fetchParams,
          headers: { ...initialHeaders, ...additionalHeaders },
        });
        setData(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    },
    [url]
  );

  return { data, loading, error, fetchData, fetchCount };
};

export default useLazyFetch;
